import RequestMaster from '../RequestMaster'

export default class RequestFile extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/images'
    }
}
